import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp, Calendar } from 'lucide-react';

interface ThreeYearForecastScreenThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function ThreeYearForecastScreenThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: ThreeYearForecastScreenThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-sm font-medium">3-Year Strategic Forecast</CardTitle>
            <Calendar className="h-4 w-4 text-muted-foreground" />
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">Year 1 (2025)</span>
              <div className="flex items-center gap-1">
                <span className="text-sm font-semibold">£3.2M</span>
                <TrendingUp className="h-3 w-3 text-green-500" />
              </div>
            </div>
            <div className="h-16 flex items-end gap-1">
              {[40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 95, 90, 85, 80, 75, 70, 65, 60, 55, 50, 45, 40, 35, 30, 25, 20, 15, 10, 5, 10, 15, 20, 25].map((height, i) => (
                <div key={i} className="flex-1 bg-gradient-to-t from-blue-500 to-blue-300 rounded-t" style={{ height: `${height}%` }} />
              ))}
            </div>
            <div className="grid grid-cols-3 gap-2 pt-2 border-t">
              <div className="text-center">
                <div className="text-xs text-muted-foreground">Year 1</div>
                <div className="text-sm font-semibold">£3.2M</div>
              </div>
              <div className="text-center">
                <div className="text-xs text-muted-foreground">Year 2</div>
                <div className="text-sm font-semibold">£4.1M</div>
              </div>
              <div className="text-center">
                <div className="text-xs text-muted-foreground">Year 3</div>
                <div className="text-sm font-semibold">£5.3M</div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
